import React, { useState, useEffect } from "react";
import SimpleSellBanner from "components/LandingPageComponents/SimpleSellBanner";
import Link from "next/link";
import marked from "marked";
import MuiIndexMarkupWrap from "components/global/MuiIndexMarkupWrap";
import { NextSeo } from "next-seo";

import BlogCard from "components/blog/BlogCard";
import MapTeaser from "components/MapTeaser";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/styles";

export async function getStaticProps() {
  const targetUrl = `${process.env.CMS_URL}/markets`;
  const res = await fetch(targetUrl);
  const BlogData = await res.json();

  const targetUrlBlogs = `${process.env.CMS_URL}/blog-posts?_limit=-1&BlogCategory=MarketOverview`;
  const resBlogs = await fetch(targetUrlBlogs);
  const BlogPostsData = await resBlogs.json();

  return {
    props: {
      BlogData,
      BlogPostsData,
    },
  };
}

export default function Blog({ BlogData, BlogPostsData }) {
  const [customStatusText, setCustomStatusText] = useState({});
  const theme = useTheme();

  useEffect(() => {
    setCustomStatusText({
      header: "Test the market, get offers",
      body: "30 seconds to list. Pay ZERO commission.",
      button: "List",
    });
  }, []);

  return (
    <>
      <NextSeo
        title={BlogData?.MetaTitle}
        description={BlogData?.MetaDescription}
        image={
          BlogData?.MetaImage && Object.keys(BlogData?.MetaImage) !== 0
            ? `${process.env.CMS_URL}${BlogData?.MetaImage.url}`
            : `${process.env.absoluteUrl}/omlogo_placeholder.png`
        }
        openGraph={{
          url: `${process.env.absoluteUrl}/blog`,
          title: BlogData?.MetaTitle,
          description: BlogData?.MetaDescription,
          images: [
            {
              url:
                BlogData?.MetaImage?.length > 0
                  ? `${process.env.CMS_URL}${BlogData?.MetaImage[0].url}`
                  : `${process.env.absoluteUrl}/omlogo_placeholder.png`,
              alt: BlogData?.MetaTitle,
            },
          ],
          site_name: "OfferMarket.us",
        }}
        twitter={{
          handle: "@OfferMarketUS",
          site: "@OfferMarketUS",
          cardType: "summary_large_image",
        }}
      />

      <MuiIndexMarkupWrap>
        <h1
          style={{
            margin: "auto",
          }}
        >
          {BlogData?.Title}
        </h1>
        <div dangerouslySetInnerHTML={{ __html: marked(BlogData?.Body) }} />

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            [theme.breakpoints.down("md")]: {},
          }}
        >
          {BlogPostsData &&
            BlogPostsData.map((blogPost, index) => {
              return (
                <Box
                  sx={{
                    margin: theme.spacing(3, 2),
                    width: "45%",
                    [theme.breakpoints.down("md")]: {
                      width: "90%",
                    },
                  }}
                >
                  <BlogCard post={blogPost} parentUrl={"/blog"} />
                </Box>
              );
            })}
        </Box>
      </MuiIndexMarkupWrap>

      <MapTeaser />

      <SimpleSellBanner customStatusText={customStatusText} wrapMargin={"0"} />
    </>
  );
}
